var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('form',{staticClass:"zpa-form no-fit",class:_vm.classes,attrs:{"id":_vm.id}},[_vm._t("default"),(_vm.$slots.actions)?_c('zpa-row',[_vm._t("actions")],2):_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }